var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPumpTrustedLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50048 2.17473e-06C7.38394 -0.000722863 6.27818 0.179851 5.24645 0.531395C4.21473 0.882938 3.2773 1.39857 2.48779 2.04875C1.69827 2.69894 1.07215 3.47093 0.645269 4.32058C0.218392 5.17023 -0.000877768 6.08085 2.64076e-06 7.00035C2.64076e-06 12.2498 8.50048 20 8.50048 20C8.50048 20 17 12.2498 17 7.00035C17.0009 6.08092 16.7817 5.17037 16.3548 4.32077C15.928 3.47118 15.302 2.69919 14.5126 2.04902C13.7231 1.39884 12.7858 0.883225 11.7542 0.531635C10.7226 0.180045 9.61695 -0.000619282 8.50048 2.17473e-06Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.10904 9.94209L13.0664 4.99111L11.7897 3.93176L7.10904 7.82339L5.22014 6.25289L3.94336 7.31224L7.10904 9.94209Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPumpTrustedLocation);
export default __webpack_public_path__ + "static/media/pump-trusted-location.f89d303279224dd10082a49ba6f3264a.svg";
export { ForwardRef as ReactComponent };